<div class="summary-div" id="importSummary">
  <h2 class="top-margin-3" id="summary-header">Data Summary</h2>
  <div *ngIf="import" id="summary-data">
    <div class="summaryContainer">
      <table id="summaryInfo" aria-hidden="true">
        <tbody>
          <tr>
            <th class="tHead">Import Id</th>
            <td class="tData">{{import.id}}</td>
          </tr>
          <tr>
            <th class="tHead">Created By</th>
            <td class="tData">{{import.user}}</td>
          </tr>
          <tr>
            <th class="tHead">Pay Date</th>
            <td class="tData">{{import.payDate | date: 'MM/dd/yyyy'}}</td>
          </tr>
          <tr *ngIf="import.submitted !== null">
            <th class="tHead">Submitted Date</th>
            <td class="tData">{{import.submitted | date: 'MM/dd/yyyy'}}</td>
          </tr>
          <tr>
            <th class="tHead">System(s)</th>
            <td class="tData">{{import.systems}}</td>
          </tr>
          <tr>
            <th class="tHead">Location(s)</th>
            <td class="tData">{{import.locationCodes}}</td>
          </tr>
           <tr>
            <th class="tHead">Contribution</th>
            <td class="tData">{{import.contribution | currency:'USD':'symbol':'1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ERROR -->
    <table id="importErrorSummaryTable" *ngIf="errorCount>0" class="fill">
      <caption class="float-left"><em>Errors</em></caption>
      <tbody>
        <tr *ngFor="let error of importErrors">
          <th><a (click)="loadIssueRecords(error.errorName, true)" class="clone-link">{{error.errorName}}</a></th>
          <td class="floatRight-NotImp">{{error.errorCount}}</td>
        </tr>
      </tbody>
    </table>

    <!-- TOTAL RECORDS -->
    <table id="importIssueSummaryTable" class="fill" *ngIf="importIssues?.length>0">
      <caption class="float-left"><em>Warnings &amp; Total Records</em></caption>
      <tfoot id="tRecords">
        <tr>
          <th><a (click)="loadIssueRecords('Total Records')" class="clone-link" id="total-Records"><dfn
                title="Click to view all records (clear filter/sort)">Total Records</dfn></a></th>
          <td class="floatRight-NotImp" id="record-count">{{import.records}}</td>
        </tr>
      </tfoot>
      <tbody>
        <tr *ngFor="let issue of importIssues;">
          <th><a (click)="loadIssueRecords(issue.issueName)" class="clone-link">
              <dfn title="Click to filter by records with any issue" *ngIf="issue.issueName === 'Total Issues'">
                {{issue.issueName === 'Total Issues' ? 'Total Records with Warnings' : issue.issueName}}
              </dfn>
              {{issue.issueName !== 'Total Issues' ? issue.issueName : ''}}
            </a>
          </th>
          <td class="floatRight-NotImp">{{issue.issueCount}}</td>
        </tr>
      </tbody>
    </table>

    <!-- STATUS -->
    <div id="importMsg" *ngIf="import.paymentStatus > 0 || (import.remittanceReconciliationId && import.revenueControlTransmittalId)">
      <p id="status">
        <dfn class="text-green" id="dataSuccessMsg"><span
            class="k-icon k-i-checkmark text-green"></span>{{dataUploadSuccessMsg}}</dfn>
      </p>
      <p *ngIf="((import.remittanceReconciliationId && import.revenueControlTransmittalId) || import.paymentStatus === 5 || import.paymentStatus === 8); else nopmnt"
        id="status">
        <dfn class="text-green" id="remittanceSuccessMsg"><span
            class="k-icon k-i-checkmark text-green"></span>{{paymentSuccessMsg}}</dfn>
      </p>
      <ng-template #nopmnt>
        <p id="status">
          <dfn class="text-warning" id="warningMsg"><span
              class="k-icon k-i-warning text-warning"></span>{{paymentIncompleteMsg}}</dfn>
        </p>
      </ng-template>

    </div>
  </div>
</div>
